import { DropdownButtonType, List, ListItem, SingleSelectDropdown, TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { VPC_BOLD_FONT_WEIGHT } from '~src/settings/styles/CommonStyles';

import { IMobileSecuritySeverityLevel } from '../serverApi/types/IMobileSecuritySettings';
import { getSeverityFieldsForPolicy } from '../utils/MobileSecuritySettingsUtils';

export type SeverityLevelProps = Readonly<{
    value: string;
    policy: string;
    testId: string;
    onDropdownChange: (policy: string, value: string) => void;
}>

export function SeverityLevelDropdown(props: SeverityLevelProps) {
  const severityFields = getSeverityFieldsForPolicy(props.policy);
  return (
    <div className={severityLevelDropdown}>
      <SingleSelectDropdown
        type={DropdownButtonType.Outline}
        value={props.value}
        list={<List items={getSeverityListItems()} className={severityLevelList}/>}
        name={severityFields ? severityFields[0] : ''}
        label={Messages.mobileSecurityPolicies_SeverityLevel_DropdownLabel()}
        testId={props.testId}
        onChange={(value: string) => props.onDropdownChange(props.policy, value)}>
        {getLabelForPolicySeverity(props.value)}
      </SingleSelectDropdown>
    </div>
  );
}

const getLabelForPolicySeverity = (value: string) => {
  return getSeverityLevelItems().find(item => item.value === value)?.label;
};

function getSeverityLevelItems() {
    return [
    {
      label: Messages.mobileSecurityPolicies_SeverityLevel_WarnLabel(),
      description: Messages.mobileSecurityPolicies_SeverityLevel_WarnDescription(),
      value: IMobileSecuritySeverityLevel.WARN,
      testId: 'allow-mobile-security-severity-level-warn'
    },
    {
      label: Messages.mobileSecurityPolicies_SeverityLevel_ErrorLabel(),
      description: Messages.mobileSecurityPolicies_SeverityLevel_ErrorDescription(),
      value: IMobileSecuritySeverityLevel.ERROR,
      testId: 'allow-mobile-security-severity-level-error'
    },
    {
      label: Messages.mobileSecurityPolicies_SeverityLevel_CriticalLabel(),
      description: Messages.mobileSecurityPolicies_SeverityLevel_CriticalDescription(),
      value: IMobileSecuritySeverityLevel.CRITICAL,
      testId: 'allow-mobile-security-severity-level-critical'
    }
   ];
  }

  function getSeverityListItems(): ListItem[] {
    let items: ListItem[] = [];
    getSeverityLevelItems().map(item => items.push({
      value: item.value,
      content: renderSeverityListItem(item.label, item.description),
      testId: item.testId
    }));
    return items;
  }

  function renderSeverityListItem(label: string, description: string): JSX.Element {
    return (<div className={severityLevelListItem}>
      <div className={severityLevelLabel}>{label}</div>
      <div className={severityLevelDescription}>{description}</div>
    </div>);
  }

  const severityLevelDropdown = style({
    maxWidth: '300px'
  });

  const severityLevelList = style({
    // Dropdown adds a 1px border
    maxWidth: '298px'
  });

  const severityLevelListItem = style({
    padding: '4px 8px',
    whiteSpace: 'normal',
    borderRadius: '2px'
  });

  const severityLevelLabel= style({
    fontWeight: VPC_BOLD_FONT_WEIGHT,
  });

  const severityLevelDescription= style({
    paddingTop: '4px',
    fontSize: TabStyles.Typography.Sizing.Tiny,
  });
